import React, { useState } from "react";
import HttpService from "../../../services/httpService";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../../redux/actions/appAction";

import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Divider,
  makeStyles
} from "@material-ui/core";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import moment from "moment";

const useStyles = makeStyles((theme) => ({
  page: {
    maxWidth: 950,
    margin: "40px auto"
  },

  card: {
    padding: 35,
    borderRadius: 10
  },

  sectionTitle: {
    fontWeight: 600,
    marginBottom: 10
  },

  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      background: "#fafafa"
    }
  },

  button: {
    marginTop: 10,
    padding: "10px 40px",
    borderRadius: 8
  },

  tableHead: {
    background: "#f4f6f8"
  }
}));

const Index = (props) => {

  const classes = useStyles();
  const [gstData, setGstData] = useState({
    uid: "",
    gstName: "",
    gstNumber: "",
    gstAddress: "",
  });
  const [gstError, setGstError] = useState({});
  const [gstLoading, setGstLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const validateGST = () => {
    const newErrors = {};
    if (!gstData.uid.trim()) newErrors.uid = "UID is required";
    if (!gstData.gstName.trim()) newErrors.gstName = "GST Name required";
    if (!gstData.gstNumber.trim()) {
      newErrors.gstNumber = "GST Number required";
    } else if (!gstRegex.test(gstData.gstNumber)) {
      newErrors.gstNumber = "Invalid GST Number";
    }
    if (!gstData.gstAddress.trim()) {
      newErrors.gstAddress = "GST Address required";
    }
    setGstError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateGST()) return;
    props.setLoading(true);
    setGstLoading(true);
    try {
      const payload = {
        uid: gstData.uid,
        gstName: gstData.gstName,
        gstNumber: gstData.gstNumber,
        gstAddress: gstData.gstAddress
      };

      const res = await HttpService.updateGstDetails(payload);
      if (res?.data?.success) {
        props.setSnackInfo(res.data.message, "success");
        setHistory((prev) => [
          ...prev,
          { ...payload, createdAt: new Date() }
        ]);
        setGstData({
          uid: "",
          gstName: "",
          gstNumber: "",
          gstAddress: ""
        });
      } else {
        props.setSnackInfo(res?.data?.message || "Failed", "error");
      }
    } catch (err) {
      props.setSnackInfo(
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    }

    setGstLoading(false);
    props.setLoading(false);
  };

  const isFormValid =
  gstData.uid.trim() &&
  gstData.gstName.trim() &&
  gstData.gstNumber.trim() &&
  gstData.gstAddress.trim() &&
  gstRegex.test(gstData.gstNumber);

  return (
    <Box className={classes.page}>
      {/* FORM CARD */}
      <Paper elevation={4} className={classes.card}>
        <Typography variant="h5" align="center" style={{ fontWeight: 700 }}>
          UPDATE GST NUMBER
        </Typography>
        <Divider style={{ margin: "25px 0" }} />
        <Typography className={classes.sectionTitle}>
          Project Information
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="Project Unique Lead Number (UID)"
              fullWidth
              className={classes.input}
              value={gstData.uid}
              error={!!gstError.uid}
              helperText={gstError.uid}
              onChange={(e) =>
                setGstData({ ...gstData, uid: e.target.value })
              }
            />
          </Grid>

        </Grid>

        <Divider style={{ margin: "30px 0" }} />

        <Typography className={classes.sectionTitle}>
          GST Information
        </Typography>

        <Grid container spacing={3}>

          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="GST Name"
              fullWidth
              className={classes.input}
              value={gstData.gstName}
              error={!!gstError.gstName}
              helperText={gstError.gstName}
              onChange={(e) =>
                setGstData({ ...gstData, gstName: e.target.value })
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="GST Number"
              fullWidth
              inputProps={{ maxLength: 15 }}
              className={classes.input}
              value={gstData.gstNumber}
              error={!!gstError.gstNumber}
              helperText={gstError.gstNumber}
              onChange={(e) =>
                setGstData({
                  ...gstData,
                  gstNumber: e.target.value.toUpperCase()
                })
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label="GST Address"
              multiline
              rows={3}
              fullWidth
              className={classes.input}
              value={gstData.gstAddress}
              error={!!gstError.gstAddress}
              helperText={gstError.gstAddress}
              onChange={(e) =>
                setGstData({
                  ...gstData,
                  gstAddress: e.target.value
                })
              }
            />
          </Grid>

          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.button}
                disabled={!isFormValid || gstLoading}
                onClick={handleSubmit}
            >
                {gstLoading ? "Saving..." : "UPDATE GST"}
            </Button>
          </Grid>

        </Grid>

      </Paper>

      {/* HISTORY TABLE */}

      {history.length > 0 && (

        <Paper elevation={3} style={{ marginTop: 40, padding: 25, borderRadius: 10 }}>

          <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 20 }}>
            GST Update History
          </Typography>

          <TableContainer>

            <Table>

              <TableHead className={classes.tableHead}>

                <TableRow>
                  <TableCell><b>UID</b></TableCell>
                  <TableCell><b>GST Name</b></TableCell>
                  <TableCell><b>GST Number</b></TableCell>
                  <TableCell><b>Address</b></TableCell>
                  <TableCell><b>Updated Date</b></TableCell>
                </TableRow>

              </TableHead>

              <TableBody>

                {history.map((row, i) => (

                  <TableRow key={i}>

                    <TableCell>{row.uid}</TableCell>
                    <TableCell>{row.gstName}</TableCell>
                    <TableCell>{row.gstNumber}</TableCell>
                    <TableCell>{row.gstAddress}</TableCell>
                    <TableCell>
                      {moment(row.createdAt).format("DD MMM YYYY")}
                    </TableCell>

                  </TableRow>

                ))}

              </TableBody>

            </Table>

          </TableContainer>

        </Paper>

      )}

    </Box>
  );
};

export default connect(null, { setLoading, setSnackInfo })(Index);